var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 9,
    viewBox: "0 0 7 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0490057 9V0.272727H1.10582V4.60227H1.2081L5.12855 0.272727H6.50923L2.84446 4.21023L6.50923 9H5.23082L2.19673 4.94318L1.10582 6.17045V9H0.0490057Z",
    fill: "#6E6E80"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKIcon);
export default __webpack_public_path__ + "static/media/KIcon.f605400a11084018279ebd98d6c903e3.svg";
export { ForwardRef as ReactComponent };